import "core-js/modules/es.array.map.js";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import SimpleModal from 'components/SimpleModal';
import Text from 'components/Text';
import Stack from 'components/Stack';
import Heading from 'components/Heading';
import { HelixChangeMyMindText, HelixEmailLink, HowHelixWorksText } from 'screens/UserSkills';
var headingProps = {
  as: 'h2',
  size: 'small',
  mb: 's'
};
var stackProps = {
  spacing: 'xs',
  mb: 'l'
};
function HelixInfoModal(_ref) {
  var onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    width: "extraWide",
    title: t('property_helix_info'),
    body: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
      as: "h2",
      size: "small",
      mb: "s"
    }, t('skills_empty_invite_helix_title')), /*#__PURE__*/React.createElement(Stack, {
      spacing: "xs",
      mb: "l"
    }, /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "skills_empty_invite_helix_text_1"
    }, "Ready to collect more data? Invite", /*#__PURE__*/React.createElement(HelixEmailLink, null, "helix@5app.com"), "to your next meeting to get started!"), ['skills_empty_invite_helix_text_2', 'skills_empty_invite_helix_text_3'].map(function (key) {
      return /*#__PURE__*/React.createElement(Text, {
        key: key
      }, t(key));
    })), /*#__PURE__*/React.createElement(HowHelixWorksText, {
      headingProps: headingProps,
      stackProps: stackProps
    }), /*#__PURE__*/React.createElement(HelixChangeMyMindText, {
      headingProps: headingProps,
      stackProps: stackProps
    })),
    buttons: [{
      variant: 'primary',
      label: t('actions_close'),
      onClick: onClose
    }],
    onClose: onClose
  });
}
export default HelixInfoModal;